var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-tmdc6gty37-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42A8B0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F6F78",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C6.71659492,0 0,6.71557215 0,15 C0,23.2844278 6.71593604,30 15,30 C23.2847228,30 30,23.2844278 30,15 C30,6.71557215 23.2847228,0 15,0 Z M15,4.48517461 C17.7409295,4.48517461 19.9620047,6.70700637 19.9620047,9.44673841 C19.9620047,12.1871294 17.7409295,14.4083022 15,14.4083022 C12.2603883,14.4083022 10.039313,12.1871294 10.039313,9.44673841 C10.039313,6.70700637 12.2603883,4.48517461 15,4.48517461 Z M14.9967056,26.0781902 C12.2630238,26.0781902 9.75929017,25.0825829 7.82812088,23.4346585 C7.35768251,23.0333846 7.08622507,22.4449813 7.08622507,21.8275862 C7.08622507,19.0489787 9.33497321,16.8251702 12.1141175,16.8251702 L17.8872002,16.8251702 C20.6670034,16.8251702 22.9071862,19.0489787 22.9071862,21.8275862 C22.9071862,22.4456402 22.6370465,23.0327257 22.1659492,23.4339996 C20.2354388,25.0825829 17.7310463,26.0781902 14.9967056,26.0781902 Z",
    id: "Shape",
    fill: "url(#linearGradient-tmdc6gty37-1)",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7d81e941f240beb09cd1c717581cf59c.svg";
export { ForwardRef as ReactComponent };